import * as React from "react";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import { ReactComponent as SearchIcon } from "../../assets/images/ralvie/search-icon-control.svg";
import { ReactComponent as CancelIcon } from "../../assets/images/ralvie/clearTextIcon-control.svg";
import { useTranslation } from "react-i18next";
import "./SearchFieldControl.scss";

export default function SearchFieldControl(props) {
  const [value, setValue] = React.useState(props.value);
  const { t } = useTranslation();

  React.useEffect(() => {
    if (value !== props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  React.useEffect(() => {
    if (props.clearSearch) {
      setValue("");
    }
  }, [props.clearSearch]);

  const handleChange = (event) => {
    const { maxLength } = props.maxLength;
    const currValue = event.target.value;


    if (maxLength && currValue.length > maxLength) {
      return;
    }

    if (value.length == 0 && currValue.trim() === '') {
      return;
    }

    if (currValue.length != 0 && currValue === '') {
      return;
    }

    if (/\s{2}/.test(currValue)) {
      return;
    }


    setValue(currValue);
    if (props.onChange) {
      props.onChange(currValue);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (props.onClick) {
        props.onClick(value);
      }
    }
  };

  const onClear = (event) => {
    if (props.onClear) {
      props.onClear();
    }
  };

  return (
    <Paper
      component="form"
      variant="outlined"
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        border: "1px solid #D9D9D9",
        borderRadius: "10px",
        opacity: 1,
        background: "transparent",
      }}
      className="Searchfileddimensions"
    >
      <InputBase
        value={value}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        sx={{
          ml: 1,
          flex: 1,
          color: "#242424 !important",
          "& input": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
          },
          "& input::placeholder": {
            color: "#242424 !important",
          },
        }}
        placeholder={props.label}
        className="input-placeholder"
        inputProps={{
          "aria-label": props.label,
          maxLength: props.maxLength || "",
        }}
      />

      {value && (

      
    
        <Tooltip title={t("RAL0693")}>
          <CancelIcon 
          className="cancelcontrol_svg"
            id={props.id}
            name={"clear"}
            type="button"
            aria-label="clear"
            onClick={() => props.onClear()}/>
        </Tooltip>
      )
      }

      <SearchIcon
        className="searchcontrol_svg"
        aria-label="search"
        id={props.id}
        name={props.name}
         type="button"
        onClick={() => props.onClick(value)}
      />
    </Paper>
  );
}